module.exports = __webpack_public_path__ + "img/about_mrdata.50bf377a.png";